import React from 'react';
import { Box, Container, Grid, Link, Typography } from '@mui/material';

function Footer() {
  return (
    <Box sx={{ backgroundColor: '#121212', color: '#eee', py: 4, mt: 6 }}>
      <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
        <Grid container spacing={4}>
          {/* Address and Contact */}
         <Grid item xs={12} md={4}>
  <Typography variant="h6" gutterBottom>
    Contact Us
  </Typography>
  <Typography variant="body2" sx={{ mt: 1 }}>
    Email: <Link href="mailto:info@wajls.com" underline="hover" color="inherit">info@wajls.com</Link>
  </Typography>
  <Typography variant="body2" sx={{ mt: 1 }}>
    Admin: <Link href="mailto:auagugo@aauekpoma.edu.ng" underline="hover" color="inherit">auagugo@aauekpoma.edu.ng</Link>
  </Typography>
</Grid>

          {/* Related Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/join-peer-review" underline="hover" color="inherit">
                Become a Peer Reviewer
              </Link>
              <Link href="/join-editorial-board" underline="hover" color="inherit">
                Join Editorial Membership Board
              </Link>
              <Link href="/submit-manuscript" underline="hover" color="inherit">
                Submit Paper
              </Link>
              {/* <Link href="#" underline="hover" color="inherit">
                Contact Us
              </Link> */}
            </Box>
          </Grid>

          {/* Policies */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Policies
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/terms-and-conditions" underline="hover" color="inherit">
                Terms and Conditions
              </Link>
              {/* <Link href="#" underline="hover" color="inherit">
                Privacy Policy
              </Link> */}
            </Box>
          </Grid>
        </Grid>
      </Container>
       {/* Bottom text */}
       <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="caption" color="gray">
            &copy; {new Date().getFullYear()} Journal Publication Platform. All rights reserved.
          </Typography>
        </Box>
    </Box>
  );
}

export default Footer;
